import React, { useState } from "react";
import CelesFloatingInputState from "../components/leasing.c.celesfloatinginputstate";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import {
  calculatePayPerMonthPerYear,
  calculatePayPerMonthReduction,
  calInterestReduction,
  getAmount,
  getNumberTwoDecimal,
  getReceiveAmountCar,
  getReceiveAmountMotobike,
  RATE,
  round,
  roundUp,
} from "../utils/leasing.u";
import { getCurrentLocalDateTime } from "utils/getLocalDateTime";
import { Auth, Storage } from "aws-amplify";
import { faker } from "@faker-js/faker";
import { useEffect } from "react";
import Button from "../components/leasing.c.button";
import API from "../api/api.main";
import { BANK_OPTIONS } from "components/Leasing/constrant/leasing.ct.options";
import Select from "react-select";
import { useSelector } from "react-redux";

export const getVendorAmountAdmin = (form) => {
  let amount = round(form.capital, 0);

  if (
    form?.estimate_car_dropdown === "เรียกเก็บ" ||
    form?.fee_motorbike_dropdown === "เรียกเก็บ"
  ) {
    amount -= round(form.capital * (form.loanFee / 100), 2);
  }

  if (form?.fee_inspection_dropdown === "เรียกเก็บ") {
    amount -= form.fee_inspection;
  }

  if (form.fee_transfer_dropdown === "เรียกเก็บ") {
    amount -= form.fee_transfer;
  }

  if (form?.stamp_dropdown === "เรียกเก็บ") {
    amount -= round(form.capital * (form.stamp / 100), 2);
  }

  return round(amount, 0);
};

export function generateCitizenId() {
  let id = "";
  for (let i = 0; i < 13; i++) {
    if (i === 0) {
      id += Math.floor(Math.random() * 9) + 1; // the first digit should not be 0
    } else {
      id += Math.floor(Math.random() * 10); // the last digit can be any number
    }
  }
  return id;
}

function FootageCreateTF({
  loading = false,
  fetchLoanLeasing,
  setDate,
  setIsChange,
}) {
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [form, setForm] = useState({
    capital: 100000,
    period: 24,
    payPerMonth: calculatePayPerMonthReduction(
      100000,
      calInterestReduction(100000, 6.3, 24),
      24
    ),
    tankNumber: `${new Date().getTime()}`,
    color: "สีดำ",

    interestPenalty: 3,
    interest: 7.89,
    interest_eff: 13.56,
    stamp: 0.05,
    loanFee: 1,
    interestReduction: calInterestReduction(100000, 6.3, 24),
    fee_inspection_dropdown: "ฟรีค่าธรรมเนียม",
    fee_transfer_dropdown: "ฟรีค่าธรรมเนียม",
    fee_service_dropdown: "ฟรีค่าธรรมเนียม",
    type: "CAR",
    fee_inspection: 1000,
    fee_transfer: 1500,
    fee_service: 1000,

    addressCode: "30",
    addressDesc: "ซอยลาดพร้าว 9",
    citizenid: `${generateCitizenId()}`,
    phone_number: "0875003282",
    email: "pichan.s@celestialcode.tech",
    address: "คลองเจ้าคุณสิงห์,วังทองหลาง,กรุงเทพมหานคร,10310",
    bank_key: BANK_OPTIONS[1]?.value,
    bank_account: "1234567890",
    account_holder: "",
    name: "",
    lastname: "",
    stamp_dropdown: "ฟรีค่าธรรมเนียม",
    estimate_car_dropdown: "ฟรีค่าธรรมเนียม",
    fee_motorbike_dropdown: "ฟรีค่าธรรมเนียม",
    year: "2022",
  });

  const [valueCalendar, onChangeCalendar] = useState(new Date("2022-01-01"));
  const { interest } = useSelector((state) => state.initializeApp);

  // console.log("reduction", calInterestReduction(form.capital, form.interest, form.period));

  const findInterestTF = (INTEREST_TF = [], year, period) => {
    let interest_tf = 0;
    let interest_tf_eff = 0;
    for (const INTEREST_TF_ITEM of INTEREST_TF) {
      if (
        String(INTEREST_TF_ITEM.name) === String(String(year)?.split(" ")[0])
      ) {
        interest_tf = INTEREST_TF_ITEM[`period_${period}`];
        interest_tf_eff = INTEREST_TF_ITEM[`period_${period}_eff`];
        break;
      }
    }

    return { interest_tf, interest_tf_eff };
  };

  useEffect(() => {
    const foundInterest = findInterestTF(
      interest.tf.INTEREST_TF,
      form.year,
      form.period
    );
    setForm((prev) => {
      return {
        ...prev,
        interest: foundInterest.interest_tf,
        interest_eff: foundInterest.interest_tf_eff,
      };
    });
  }, [form.year, form.period]);

  useEffect(() => {
    const name = faker.name.firstName();
    const lastname = faker.name.lastName();

    setForm((prev) => {
      return {
        ...prev,
        name,
        lastname,
      };
    });
    setDate(valueCalendar);
  }, [valueCalendar]);

  const onChangeFormCreate = (e) => {
    let { name, value } = e.target;
    setForm((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const onChangeType = (newType) => {
    setForm((prev) => {
      let samoObj = { ...prev };
      if (newType === "CAR") {
        samoObj = {
          ...samoObj,
          loanFee: 1,
        };
      } else {
        samoObj = {
          ...samoObj,
          loanFee: 9,
        };
      }

      return {
        ...samoObj,
        type: newType,
      };
    });
  };

  const createLoan = async () => {
    try {
      setLoadingCreate(true);
      const requestTime = getCurrentLocalDateTime(valueCalendar);

      let newLeasing = {
        name: form.name,
        lastname: form.lastname,
        fullname: `${form.name} ${form.lastname}`,
        phone_number: form.phone_number,
        citizenid: form.citizenid,
        addressCode: form.addressCode,
        addressDesc: form.addressDesc,
        address: form.address,
        promo: 0,
        bankNo: form.bank_account,
        raw_interest: form.interest,
        interest: form.interest,
        interestPenalty: form.interestPenalty,
        period: form.period,
        type: form.type,
        requestTime: requestTime.isoDateTime,
        initCapital: form.capital,
        loanFee: form.loanFee,
        stamp: form.stamp,
        category: "TF",
        purpose: "เช่าซื้อ",
        color: form.color,
        tankNumber: form.tankNumber,

        year: form.year,
        article: "Mr.",
        bankAccName: `${form.name} ${form.lastname}`,
        email: form.email,
        bank: form.bank_key,
        fee_inspection_dropdown: form.fee_inspection_dropdown,
        fee_service_dropdown: form.fee_service_dropdown,
        fee_inspection: form.fee_inspection,
        stamp_dropdown: form.stamp_dropdown,
        stamp_amount: round(form.capital * (form.stamp / 100), 2),
        estimate_car_amount:
          form.estimate_car_dropdown === "เรียกเก็บ" && form.type === "CAR"
            ? round(form.capital * (form.loanFee / 100), 2)
            : 0,
        fee_motorbike_amount:
          form?.fee_motorbike_dropdown === "เรียกเก็บ" &&
          form.type === "MOTORBIKE"
            ? round(form.capital * (form.loanFee / 100), 2)
            : 0,
        estimate_car_vat:
          form?.estimate_car_dropdown === "เรียกเก็บ" && form.type === "CAR"
            ? round(form.capital * (form.loanFee / 100) * (7 / 100), 2)
            : 0,
        fee_motorbike_vat:
          form?.fee_motorbike_dropdown === "เรียกเก็บ" &&
          form.type === "MOTORBIKE"
            ? round(form.capital * (form.loanFee / 100) * (7 / 100), 2)
            : 0,
        fee_inspection:
          form.fee_inspection_dropdown === "เรียกเก็บ"
            ? form.fee_inspection
            : 0,
        fee_transfer:
          form.fee_transfer_dropdown === "เรียกเก็บ" ? form.fee_transfer : 0,
        fee_transfer_vat:
          form?.fee_transfer_dropdown === "เรียกเก็บ"
            ? round(form.fee_transfer * (7 / 100), 2)
            : 0,
        fee_service:
          form.fee_service_dropdown === "เรียกเก็บ" ? form.fee_service : 0,
        fee_service_vat:
          form?.fee_service_dropdown === "เรียกเก็บ"
            ? round(form.fee_service * (7 / 100), 2)
            : 0,
      };

      await API.post("MoneyHubAdmin", "/leasing/loanSandbox", {
        body: {
          ...newLeasing,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      await fetchLoanLeasing();
      const name = faker.name.firstName();
      const lastname = faker.name.lastName();

      setForm((prev) => {
        return {
          ...prev,
          tankNumber: `${new Date().getTime()}`,
          name,
          lastname,
          citizenid: `${generateCitizenId()}`,
        };
      });
    } catch (error) {
      console.log("error ", error);
    } finally {
      setLoadingCreate(false);
    }
  };

  return (
    <div className="border border-gray-300 rounded-lg bg-white p-4">
      <div className="grid grid-cols-3 gap-4">
        <div className=" inline-block">
          <div className="text-gray-700 font-bold  w-full mb-4 ">
            สร้างสินเชื่อ
          </div>

          <CelesFloatingInputState
            label="Tax ID"
            onChange={onChangeFormCreate}
            value={`${form.citizenid}`}
            name="citizenid"
            maxLength={13}
          />
          <div className="h-2"></div>
          <CelesFloatingInputState
            label="Chassis Number"
            // disable
            onChange={onChangeFormCreate}
            value={`${form.tankNumber}`}
            name="tankNumber"
            maxLength={20}
          />
          <div className="h-2"></div>
          <CelesFloatingInputState
            label="Chassis Number"
            // disable
            onChange={onChangeFormCreate}
            value={`${form.color}`}
            name="color"
            maxLength={10}
          />
          <div className="h-2"></div>
          <CelesFloatingInputState
            label="Mobile Phone"
            // disable
            onChange={onChangeFormCreate}
            value={`${form.phone_number}`}
            name="phone_number"
            maxLength={10}
          />
          <div className="h-2"></div>
          <CelesFloatingInputState
            label="Email"
            // disable
            onChange={onChangeFormCreate}
            value={`${form.email}`}
            name="email"
          />
          <div className="h-2"></div>
          <div className="">ธนาคาร</div>
          <Select
            placeholder="ธนาคาร"
            label={"ธนาคาร"}
            value={{
              label: form?.bank_key,
              value: form?.bank_key,
            }}
            name="bank"
            onChange={(e) => setForm({ ...form, bank_key: e.value })}
            options={BANK_OPTIONS.slice(1, BANK_OPTIONS?.length)}
            width="w-56"
          />
          <div className="h-2"></div>
          <CelesFloatingInputState
            label="Bank Account"
            onChange={onChangeFormCreate}
            value={`${form.bank_account}`}
            name="bank_account"
            maxLength={10}
          />

          <div className="h-2"></div>
          <CelesFloatingInputState
            label="addressCode"
            // disable
            onChange={onChangeFormCreate}
            value={`${form.addressCode}`}
            name="addressCode"
          />
          <div className="h-2"></div>
          <CelesFloatingInputState
            label="addressDesc"
            // disable
            onChange={onChangeFormCreate}
            value={`${form.addressDesc}`}
            name="addressDesc"
          />

          <div className="h-2"></div>
          <CelesFloatingInputState
            label="address"
            // disable
            onChange={onChangeFormCreate}
            value={`${form.address}`}
            name="address"
          />
          <div className="h-2"></div>
          <CelesFloatingInputState
            label="Account Holder"
            // disable
            onChange={onChangeFormCreate}
            value={`${form.name} ${form.lastname}`}
            name="name"
          />
          <div className="h-2"></div>
          <div className="">ค่าอากรแสตมป์</div>
          <Select
            placeholder="ค่าอากรสแตปม์"
            label={"ค่าอากรสแตปม์"}
            value={{
              label: form?.stamp_dropdown,
              value: form?.stamp_dropdown,
            }}
            name="stamp_dropdown"
            onChange={(e) => setForm({ ...form, stamp_dropdown: e.value })}
            options={[
              {
                label: "ฟรีค่าธรรมเนียม",
                value: "ฟรีค่าธรรมเนียม",
              },
              {
                label: "เรียกเก็บ",
                value: "เรียกเก็บ",
              },
            ]}
            width="w-56"
          />
          <div className="h-2"></div>
          <CelesFloatingInputState
            label="Stamp Duty Amout (%)"
            disable={form?.stamp_dropdown === "ฟรีค่าธรรมเนียม"}
            onChange={onChangeFormCreate}
            value={`${form.stamp}`}
            name="stamp"
          />

          <div className="h-2"></div>
          <div className="">
            {form.type === "CAR"
              ? "ค่าประเมินรถยนต์"
              : "ค่าธรรมเนียมการใช้วงเงิน"}
          </div>
          <Select
            value={{
              label:
                form.type === "CAR"
                  ? form.estimate_car_dropdown
                  : form?.fee_motorbike_dropdown,
              value:
                form.type === "CAR"
                  ? form.estimate_car_dropdown
                  : form?.fee_motorbike_dropdown,
            }}
            onChange={(e) =>
              setForm({
                ...form,
                [form.type === "CAR"
                  ? "estimate_car_dropdown"
                  : "fee_motorbike_dropdown"]: e.value,
              })
            }
            options={[
              {
                label: "ฟรีค่าธรรมเนียม",
                value: "ฟรีค่าธรรมเนียม",
              },
              {
                label: "เรียกเก็บ",
                value: "เรียกเก็บ",
              },
            ]}
            width="w-56"
          />

          <div className="h-2"></div>
          <CelesFloatingInputState
            disable={
              form[
                form.type === "CAR"
                  ? "estimate_car_dropdown"
                  : "fee_motorbike_dropdown"
              ] === "ฟรีค่าธรรมเนียม"
            }
            label={`${
              form.type === "CAR"
                ? "Revenue Car Amount (%)"
                : "Revenue MTC Amount (%)"
            }`}
            // disable
            name={"loanFee"}
            onChange={onChangeFormCreate}
            value={
              form[
                form.type === "CAR"
                  ? "estimate_car_dropdown"
                  : "fee_motorbike_dropdown"
              ] === "เรียกเก็บ"
                ? form.loanFee
                : "0"
            }
          />

          <div className="border-gray-200 p-3 border mt-2">
            {form.type === "CAR"
              ? "ค่าประเมินรถยนต์"
              : "ค่าธรรมเนียมการใช้วงเงิน"}{" "}
            Vat{" "}
            {form[
              form.type === "CAR"
                ? "estimate_car_dropdown"
                : "fee_motorbike_dropdown"
            ] === "ฟรีค่าธรรมเนียม"
              ? "0"
              : round(form.capital * (form.loanFee / 100) * (7 / 100), 2)}
          </div>

          <div className="h-2"></div>
          <div className="">ค่าตรวจสภาพรถ</div>
          <Select
            value={{
              label: form?.fee_inspection_dropdown,
              value: form?.fee_inspection_dropdown,
            }}
            onChange={(e) =>
              setForm({
                ...form,
                fee_inspection_dropdown: e.value,
              })
            }
            options={[
              {
                label: "ฟรีค่าธรรมเนียม",
                value: "ฟรีค่าธรรมเนียม",
              },
              {
                label: "เรียกเก็บ",
                value: "เรียกเก็บ",
              },
            ]}
            width="w-56"
          />

          <div className="h-2"></div>
          <CelesFloatingInputState
            label={`ค่าตรวจสภาพรถ`}
            disable={form.fee_inspection_dropdown === "ฟรีค่าธรรมเนียม"}
            name={`fee_inspection`}
            onChange={onChangeFormCreate}
            value={
              form.fee_inspection_dropdown === "ฟรีค่าธรรมเนียม"
                ? "0"
                : form.fee_inspection
            }
          />

          <div className="h-2"></div>
          <div className="">ค่าโอนทะเบียนกรรมสิทธิ์</div>
          <Select
            value={{
              label: form?.fee_transfer_dropdown,
              value: form?.fee_transfer_dropdown,
            }}
            onChange={(e) =>
              setForm({
                ...form,
                fee_transfer_dropdown: e.value,
              })
            }
            options={[
              {
                label: "ฟรีค่าธรรมเนียม",
                value: "ฟรีค่าธรรมเนียม",
              },
              {
                label: "เรียกเก็บ",
                value: "เรียกเก็บ",
              },
            ]}
            width="w-56"
          />

          <div className="h-2"></div>
          <CelesFloatingInputState
            label={`ค่าโอนทะเบียนกรรมสิทธิ์`}
            disable={form.fee_transfer_dropdown === "ฟรีค่าธรรมเนียม"}
            name={`fee_transfer`}
            onChange={onChangeFormCreate}
            value={
              form.fee_transfer_dropdown === "ฟรีค่าธรรมเนียม"
                ? "0"
                : form.fee_transfer
            }
          />

          <div className="h-2"></div>
          <div className="">ค่าบริการ</div>
          <Select
            value={{
              label: form?.fee_service_dropdown,
              value: form?.fee_service_dropdown,
            }}
            onChange={(e) =>
              setForm({
                ...form,
                fee_service_dropdown: e.value,
              })
            }
            options={[
              {
                label: "ฟรีค่าธรรมเนียม",
                value: "ฟรีค่าธรรมเนียม",
              },
              {
                label: "เรียกเก็บ",
                value: "เรียกเก็บ",
              },
            ]}
            width="w-56"
          />

          <div className="h-2"></div>
          <CelesFloatingInputState
            label={`ค่าบริการ`}
            disable={form.fee_service_dropdown === "ฟรีค่าธรรมเนียม"}
            name={`fee_service`}
            onChange={onChangeFormCreate}
            value={
              form.fee_service_dropdown === "ฟรีค่าธรรมเนียม"
                ? "0"
                : form.fee_service
            }
          />

          <div className="border-gray-200 p-3 border mt-2">
            ค่าบริการ Vat{" "}
            {form.fee_service_dropdown === "ฟรีค่าธรรมเนียม"
              ? "0"
              : round(form.fee_service * (7 / 100), 2)}
          </div>

          <div className="h-2"></div>
          <div className="">ปีรถ</div>
          <Select
            placeholder="ปีรถ"
            label={"ปีรถ"}
            value={{
              label: form?.year,
              value: form?.year,
            }}
            name="year"
            onChange={(e) => setForm({ ...form, year: e.value })}
            options={new Array(10).fill(0).map((_, i) => {
              return {
                label: `${new Date().getFullYear() - 1 - i}`,
                value: `${new Date().getFullYear() - 1 - i}`,
              };
            })}
            width="w-56"
          />

          <div className="h-2"></div>
          <CelesFloatingInputState
            label="เงินต้น"
            onChange={onChangeFormCreate}
            value={form.capital}
            name="capital"
          />
          {/* <div className="h-2"></div> */}
          {/* <CelesFloatingInputState
            label="จำนวนงวด"
            onChange={onChangeFormCreate}
            value={form.period}
            name="period"
          /> */}
          <div className="h-2"></div>
          <div className="">จำนวนงวด</div>
          <Select
            placeholder="จำนวนงวด"
            label={"จำนวนงวด"}
            value={{
              label: form?.period,
              value: form?.period,
            }}
            name="period"
            onChange={(e) => setForm({ ...form, period: e.value })}
            options={[
              { label: "12", value: 12 },
              { label: "24", value: 24 },
              { label: "36", value: 36 },
              { label: "48", value: 48 },
              { label: "60", value: 60 },
            ]}
            width="w-56"
          />
          {/* <CelesFloatingInputState
            label="ดอกเบี้ยต่อปี (Flat Rate)"
            onChange={onChangeFormCreate}
            value={form.interest}
            name="interest"
          /> */}
          <div className="h-2"></div>
          <CelesFloatingInputState
            label="ดอกเบี้ยผิดนัด"
            onChange={onChangeFormCreate}
            value={form.interestPenalty}
            name="interestPenalty"
          />
          <div className="grid grid-cols-1 cursor-pointer text-center my-2 border border-blue-400">
            <div
              onClick={() => onChangeType("CAR")}
              className={
                form.type === "CAR"
                  ? "bg-blue-400 text-white p-1"
                  : "p-1 text-blue-400"
              }
            >
              รถยนต์
            </div>
            {/* <div
              onClick={() => onChangeType("MOTORBIKE")}
              className={
                form.type === "MOTORBIKE"
                  ? "bg-blue-400 text-white p-1"
                  : "p-1 text-blue-400"
              }
            >
              มอเตอร์ไซต์
            </div> */}
          </div>
          {form.type === "CAR" ? (
            <div className="flex flex-col space-y-1">
              {/* <CelesFloatingInputState
                label="ค่าประเมินราคารถยนต์ (%)"
                onChange={onChangeFormCreate}
                value={form.loanFee}
                name="loanFee"
              />
              <CelesFloatingInputState
                label="ค่าอากรแสตมป์ (%)"
                onChange={onChangeFormCreate}
                value={form.stamp}
                name="stamp"
              /> */}
              {/* <CelesFloatingInputState
                label="ค่าตรวจสภาพรถ"
                onChange={onChangeFormCreate}
                value={form.fee_inspection}
                name="fee_inspection"
              />
              <CelesFloatingInputState
                label="ค่าโอนทะเบียนกรรมสิทธิ์"
                onChange={onChangeFormCreate}
                value={form.fee_transfer}
                name="fee_transfer"
              /> */}
            </div>
          ) : (
            <></>
            // <div className="flex flex-col space-y-1">
            //   <CelesFloatingInputState
            //     label="ค่าธรรรมเนียมการใช้วงเงิน (%)"
            //     onChange={onChangeFormCreate}
            //     value={form.loanFee}
            //     name="loanFee"
            //   />
            //   <CelesFloatingInputState
            //     label="ค่าอากรแสตมป์ (%)"
            //     onChange={onChangeFormCreate}
            //     value={form.stamp}
            //     name="stamp"
            //   />
            // </div>
          )}

          {/* <div className="text-base mt-4 font-light text-gray-600">
            ดอกเบี้ยลดต้นลดดอก{" "}
            <span className="font-bold">
              {" "}
              {calInterestReduction(form.capital, form.interest, form.period)}
            </span>{" "}
            % ต่องวด
          </div> */}

          <div className="text-base mt-4 font-light text-gray-600">
            ดอกเบี้ย (Flat Rate){" "}
            <span className="font-bold">{form.interest}</span> % ต่อปี
          </div>
          <div className="text-base mt-2 font-light text-gray-600">
            ดอกเบี้ย (Effective Rate){" "}
            <span className="font-bold">{form.interest_eff}</span> % ต่อปี
          </div>
          <div className="text-base mt-2 font-light text-gray-600">
            ดอกเบี้ยผิดนัด{" "}
            <span className="font-bold">{form.interestPenalty}</span> % ต่อปี
          </div>
          <div className="text-base mt-2 font-light text-gray-600">
            เงินทุน{" "}
            <span className="font-bold">
              {Number(form?.capital)?.toLocaleString()}
            </span>{" "}
            บาท
          </div>
          <div className="text-base mt-2 font-light text-gray-600">
            เงินที่ลูกค้าได้รับ&nbsp;
            {form.type === "CAR" ? (
              <span className="font-bold">
                {/* {round(getReceiveAmountCar(form), 0)} */}
                {Number(round(getVendorAmountAdmin(form), 0)).toLocaleString()}
              </span>
            ) : (
              <span className="font-bold">
                {round(getReceiveAmountMotobike(form), 0)}
              </span>
            )}
            &nbsp;บาท
          </div>
          <div className="text-base mt-2 font-light text-gray-600">
            ผ่อนชำระ{" "}
            <span className="font-bold">
              {round(
                calculatePayPerMonthPerYear(
                  form.capital,
                  form.interest,
                  form.period
                ),
                2
              ).toLocaleString()}
            </span>{" "}
            บาท/เดือน
          </div>

          <div className="text-base mt-2 font-light text-gray-600">
            ภาษี{" "}
            <span className="font-bold">
              {Number(
                round(
                  calculatePayPerMonthPerYear(
                    form.capital,
                    form.interest,
                    form.period
                  ),
                  2
                ) * 0.07
              ).toLocaleString()}
            </span>{" "}
            บาท/เดือน
          </div>

          <button
            onClick={createLoan}
            className="p-2 border border-blue-400 text-blue-500 w-full mt-2 flex items-center justify-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className={
                (loadingCreate ? "" : "hidden") + " animate-spin  h-6 w-6 mr-3"
              }
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>
            สร้างสินเชื่อ
          </button>
          <button
            onClick={fetchLoanLeasing}
            className="p-2 border border-blue-400 text-blue-500 w-full mt-2 flex items-center justify-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className={
                (loading ? "" : "hidden") + " animate-spin  h-6 w-6 mr-3"
              }
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>
            Refresh
          </button>
        </div>
        <div></div>
        <div>
          <div className="font-bold mb-4">วันที่ปัจจุบัน</div>
          <Calendar
            locale="th-TH"
            onChange={onChangeCalendar}
            value={valueCalendar}
          />
          <Button
            className="bg-green-500 mt-2 rounded-sm hover:bg-green-600 transition-colors duration-300"
            onClick={() => setIsChange((prev) => !prev)}
          >
            ยืนยัน
          </Button>
        </div>
      </div>
    </div>
  );
}

export default FootageCreateTF;
